import React, { useState, useEffect } from "react";
import Card from "../Card/Card.jsx";
import ImageShow from "./ImageShow.jsx";
import { about_sidebar_title, about_sidebar_text } from "./sidebar.json";

import "./sidebar.css";

const SidebarAbout = ({ lang }) => {
  const images = [
    process.env.PUBLIC_URL + "/images/IMG_0357.jpg",
    process.env.PUBLIC_URL + "/images/IMG_0359.jpg",
    process.env.PUBLIC_URL + "/images/IMG_5345.jpg",
    process.env.PUBLIC_URL + "/images/IMG_9485.jpg",
  ];

  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const id = setTimeout(() => {
      setCurrentImage((currentImage + 1) % images.length);
    }, 5000);
    return () => {
      clearTimeout(id);
    };
  }, [currentImage]);

  return (
    <Card styleProps="sidebarCard">
      <div className="sidebarHeader">
        <span>{about_sidebar_title[lang]}</span>
      </div>
      <div className="sidebarImageContainer">
        <ImageShow images={images} time={5000} />
      </div>
      <div className="sidebarText">{about_sidebar_text[lang]}</div>
    </Card>
  );
};

export default SidebarAbout;



// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/SidebarAbout.jsx